/**
 * Copyright(c) Live2D Inc. All rights reserved.
 *
 * Use of this source code is governed by the Live2D Open Software license
 * that can be found at https://www.live2d.com/eula/live2d-open-software-license-agreement_en.html.
 */

import { LogLevel } from '@framework/live2dcubismframework';

/**
 * 示例应用使用的常量
 */

// 画布宽度和高度像素值，或动态屏幕尺寸（'auto'）。
export const CanvasSize: { width: number; height: number } | 'auto' = 'auto';

// 画布数量
export const CanvasNum = 1;

// 画面
export const ViewScale = 1.0;
export const ViewMaxScale = 2.0;
export const ViewMinScale = 0.8;

export const ViewLogicalLeft = -1.0;
export const ViewLogicalRight = 1.0;
export const ViewLogicalBottom = -1.0;
export const ViewLogicalTop = 1.0;

export const ViewLogicalMaxLeft = -2.0;
export const ViewLogicalMaxRight = 2.0;
export const ViewLogicalMaxBottom = -2.0;
export const ViewLogicalMaxTop = 2.0;

// 博客整合：使用绝对路径，兼容任意页面URL
export const ResourcesPath = '/live2d/Resources/';
export const ShaderPath = '/live2d/Framework/Shaders/WebGL/';

// 模型后面的背景图像文件
export const BackImageName = 'back_class_normal.png';

// 齿轮
export const GearImageName = 'icon_gear.png';

// 退出按钮
export const PowerImageName = 'CloseNormal.png';

// 模型定义---------------------------------------------
// 存放模型的目录名数组
// 目录名需要与model3.json的名称保持一致
export const ModelDir: string[] = ['维多利加'];
export const ModelDirSize: number = ModelDir.length;

// 与外部定义文件（json）保持一致
export const MotionGroupIdle = 'Idle'; // 待机
export const MotionGroupTapBody = 'TapBody'; // 点击身体时

// 与外部定义文件（json）保持一致
export const HitAreaNameHead = 'Head';
export const HitAreaNameBody = 'Body';

// 动作的优先级常量
export const PriorityNone = 0;
export const PriorityIdle = 1;
export const PriorityNormal = 2;
export const PriorityForce = 3;

// MOC3一致性验证选项
export const MOCConsistencyValidationEnable = true;
// motion3.json一致性验证选项
export const MotionConsistencyValidationEnable = true;

// 调试日志的显示选项
export const DebugLogEnable = true;
export const DebugTouchLogEnable = true;

// Framework输出的日志级别设置
export const CubismLoggingLevel: LogLevel = LogLevel.LogLevel_Verbose;

// 默认的渲染目标尺寸
export const RenderTargetWidth = 1900;
export const RenderTargetHeight = 1000;
